import React from 'react'
import data from './Aboutdata1.js'
import TimelineItem1 from './TimelineItem1.js'
import styles from './Timeline1.module.css'

const Timeline1=()=> data.length > 0 && (
    <div className={styles.timeline_container}>
        {data.map((dta,idx)=>(
            <TimelineItem1 data={dta} key={idx}/>
        ))}
    </div>
);

export default Timeline1